import i18n from '@/modules/i18n/i18n'

export type DateType = Date | null | undefined

// DatePicker
export interface DatePickerRange {
  from: DateType
  to: DateType
}
export interface DatePickerProps {
  disableDropdown?: boolean
  dropdownDefault?: DatePickerDropdownValue
  dropdownOptions?: DatePickerDropdownValue[]
  range: DatePickerRange
  rangeLimit?: number
  maxDate?: DateType
  minDate?: DateType
  requireDates?: boolean
  onOpen?: () => void
  onClose?: () => void
  setRange: (range: DatePickerRange) => void
}

export const getDatePickerErrors = () => {
  const { t } = i18n

  return {
    invalid: t('datePicker.invalidDate', 'Invalid date format'),
    required: t('datePicker.dateRequired', 'Date input is required'),
  } as const
}

export interface DatePickerErrorProps {
  to?: string
  from?: string
}
export type DatePickerDropdownValue =
  'custom' | 'singleDay' | 'noStart' | 'noEnd' | 'thisMonth' | 'lastMonth'
